import React, { useEffect } from 'react';
import i18n from 'i18n';
import { Col, Form, Row } from 'react-bootstrap';
import BzFormControlWithHook from 'components/forms/BzFormControlWithHook';
import { CallbackFn, useFormInput, ValidatorType } from 'hooks/useFormInput';
import Locations from 'views/MockServices/Tabs/MockServices/Locations';
import { BlazeLocation } from 'store/mockServices/mockServiceActions';
import { BlazeDropdownItem } from 'components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import ElevioTooltip from '../../overlays/helpTooltip/TitleHelpTooltip/ElevioTooltip';
import Autofocus from '../../forms/Autofocus/Autofocus';

interface ConfigurationProps {
  location: BlazeLocation;
  onChangeLocation: (location: string) => void;
  mockServiceName: string;
  updateMockServiceName: (smName: string, isValid: boolean) => void;
  exportSelected: (location: BlazeDropdownItem) => void;
}

const Configuration = (props: ConfigurationProps) => {
  const nameInput = useFormInput(
    props.mockServiceName,
    (fn: CallbackFn) => {
      props.updateMockServiceName(fn.value as string, fn.isValid);
    },
    {
      type: ValidatorType.REQUIRED,
      invalidMessage: i18n.t('wizard:details.configuration.msNameRequired'),
    },
    {
      type: ValidatorType.MAX_LENGTH,
      value: 250,
      invalidMessage: i18n.t('wizard:details.configuration.msNameMaxLength'),
    },
    {
      type: ValidatorType.INVALID_LEADING_SPACES,
      invalidMessage: i18n.t('wizard:details.configuration.msNameIsInvalid'),
    },
    {
      type: ValidatorType.INVALID_CHARACTERS,
      invalidMessage: i18n.t('wizard:details.configuration.msNameIsInvalid'),
    },
  );

  useEffect(() => {
    nameInput.resetValue(props.mockServiceName);
  }, [props.mockServiceName]);

  return (
    <div>
      <h2>{i18n.t('wizard:details.configuration.title')}</h2>
      <br />
      <p>{i18n.t('wizard:details.configuration.description')}</p>

      <Row>
        <Col md={4}>
          <Form.Group controlId="qa-input-transaction-name-te">
            <div className="form-group-heading">
              <Form.Label>
                {i18n.t('wizard:details.configuration.mockServiceName')}
                <ElevioTooltip elevioId={'Service_MockService_table'} id={'mockServicesHelpId'}></ElevioTooltip>
              </Form.Label>
            </div>
            <div className="position-relative">
              <Autofocus>
                <BzFormControlWithHook
                  autoComplete="off"
                  disabled={false}
                  useFormInputHook={nameInput}
                  placeholder={i18n.t('wizard:details.configuration.mockServiceName')}
                  required={true}
                  hideErrors={true}
                />
              </Autofocus>
              <div className="text-muted small mt-2">
                {i18n.t('wizard:details.configuration.mockServiceNameExplanation')}
              </div>
              {!nameInput.valid && <div className="invalid-feedback"> {nameInput.invalidMessage}</div>}
            </div>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <div className="form-group-heading">
            <label htmlFor={'wizard-location-picker'}>
              {i18n.t('wizard:details.configuration.location')}
              <ElevioTooltip elevioId={'location-name-help'} id={'locationNameHelp'} />
            </label>
          </div>
          <div>
            <Locations
              id={'wizard-location-picker'}
              onChangeLocation={props.onChangeLocation}
              manualPreLoad={true}
              rowData={props.location}
              locationPickerState={false}
              selectFirstItem={props.location.shipId === null}
              exportSelected={props.exportSelected}
            />
          </div>
          <div className="text-muted small mt-2">{i18n.t('wizard:details.configuration.locationExplanation')}</div>
        </Col>
      </Row>
    </div>
  );
};

export default Configuration;
